<div class="modal-header">
    <h2  i18n="@@proposals.set_default_terms">Set Default Terms</h2>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="activeModal.dismiss()" >
        <svg version="1.1" x="0px" y="0px" width="14" height="14"  viewBox="0 0 14 14">
            <path class="icon-stroke" fill="none" stroke-width="2" stroke-linecap="square" d="M2.8,11.2l8.5-8.5 M2.8,2.8l8.5,8.5"/>
        </svg>
    </button>
</div>
<div class="modal-body">
  <form [formGroup]="editTermForm" (ngSubmit)="submit()" class="invoice-terms-form" #docEditTermForm="ngForm">
    <div role="fieldgroup">
      <textarea formControlName="description" ></textarea>
    </div>
  </form>
</div>
<div class="modal-footer">
    <button type="button" (click)="docEditTermForm.ngSubmit.emit()" class="tu-btn pink" [disabled]="!editTermForm.valid"  i18n="@@button.save">Save </button>
</div>
